import React from 'react';

function AboutSection() {
  const products = [
    {
      id: 1,
      name: 'Perfumes',
      image: '/images/products/perfume.jpeg',
      category: 'perfumes'
    },
    {
      id: 2,
      name: 'Fragancias',
      image: '/images/products/fragancia.jpeg',
      category: 'fragancias'
    },
    {
      id: 3,
      name: 'Difusores',
      image: '/images/products/difusores.jpeg',
      category: 'difusores'
    },
    {
      id: 4,
      name: 'Aceites Aromáticos',
      image: '/images/products/aceitearomatico.jpeg',
      category: 'aceites'
    }
  ];

  const handleShopClick = (category) => {
    window.location.hash = `shop`;
    // Si necesitas pasar la categoría, puedes usar localStorage o state management
    localStorage.setItem('selectedCategory', category);
  };

  return (
    <section className="about-section">
      <div className="about-content-new">
        <h2 className="about-title-simple">Explora Nuestros Productos</h2>
        <p className="about-subtitle">Fragancias únicas que despiertan emociones</p>
        
        <div className="products-grid">
          {products.map((product) => (
            <div key={product.id} className="product-card-about">
              <div className="product-image-wrapper">
                <img src={product.image} alt={product.name} />
              </div>
              <h3>{product.name}</h3>
              <button 
                className="shop-now-btn"
                onClick={() => handleShopClick(product.category)}
              >
                Comprar Ahora
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
